export class Sales {
  SaleM: SaleM;
  SaleDs: SaleDs[];
  constructor() {
    this.SaleM = new SaleM();
    this.SaleDs = [];
  }
}

export class SaleM {
  Date: string;
  SaleNo: string;
  StoreName: string;
  /**總金 */
  TotalAmount: number;
  /**點數 */
  UsedPoint: number;
  /**支付工具(多) */
  Pays: Payment[] = [];
  isSale: boolean;
  constructor(init?: Partial<SaleM>) {
    Object.assign(this, init);
    this.Pays = [];
  }
}

export class SaleDs {
  ItemNo: string;
  ItemName: string;
  /**實際總價 */
  ActualPrice: number;
  /**單價 */
  Price: number;
  /**數量 */
  Qty: number;
}

export class Payment {
  PayTypeName: string;
  Amount: number;
}
